import PropTypes from 'prop-types';
import * as React from 'react';
import {Routes,
  Route,
  BrowserRouter} from 'react-router-dom';

import {ROUTE_MAPPING} from '../../constants/routes';
import {ADMIN_ROLE, SUBMITTER_ROLE, EDITOR_ROLE, EM_ROLE, BCFP_ROLES_ARR} from '../../constants/global';
import {Home, NotFound, CategoryPage, AdminPage, OrganizationPage, LegalNoticePage, DegreeOfferredPerMajors, APCP} from '../pages';
import BCF_READY from '../pages/Home/BCF_READY';
import BFCP_HE_LOCK from '../pages/Home/BFCP_HE_LOCK';
import WRONGPAGEPF from '../pages/Home/WrongPagePF';
import APIERRORPAGE from '../pages/Home/APIErrorPage';

/**
 * main page and routing
 * @param {object} props object containing all component props
 * @param {boolean} props.authenticated denotes if user is authenticated
 * @param {boolean} props.authenticationError denotes if user has authentication error
 * @param {boolean} props.isInvalidClock denotes if user's system time is out of sync from actual time
 * @param {boolean} props.userInfoError denotes if user's info error
 * @return {ReactElement} HTML markup
 */

export const VCF = props => {
  const[cb_user, setCBUSER] = React.useState('pf');
  const [decoder, setDecoder] = React.useState([]);

  React.useEffect(() => {
    const decodeToken = decodePayload(cb.core.iam.getJWTToken());
    if(decodeToken?.cb.ro === undefined) {
      const arr = [{rid: '-800', oid: '-128225'}];
      setDecoder(arr);
    } else {
      setDecoder(decodeToken.cb.ro);
      setCBUSER(decodePayload(cb.core.iam.getJWTToken()).cb.ns);
    }
  }, []);

  const {
    // errors
    invalidClockError,
    timedOut,
    catapultError
  } = props;

  const authenticationError = catapultError || invalidClockError || timedOut;
  if (authenticationError) {
    const routes = ROUTE_MAPPING.ERROR;
    const errorRoute =
      (invalidClockError && routes.CLOCK) ||
      (catapultError && routes.CATAPULT) ||
      (timedOut && routes.TIMEOUT);
    return window.location.replace(`${errorRoute}`);
  }

  const sroles = [SUBMITTER_ROLE, ADMIN_ROLE, EDITOR_ROLE, EM_ROLE];

  return (
    <BrowserRouter>
      <Routes>
    {/* HOME PAGE and ERROR PAGE */}
        {cb_user==='pf' && <Route path="/" element={<Home />} />}
        {cb_user==='pf' && <Route path='/bfcp-dashboard' element={<Home />} />}
        {cb_user==='pf' && getRole(decoder)[0]===ADMIN_ROLE && <Route path='/adminpage' element={<AdminPage />} />}

        {cb_user==='pf' && getRole(decoder)[0]===EM_ROLE &&  <Route path='/bfcp-select-organization' element={<OrganizationPage />} />}
        {cb_user==='pf' && sroles.includes(getRole(decoder)[0]) && <Route path='/bfcp-select-organization' element={<OrganizationPage />} />}
    {/* ERROR, INVALID PAGE, HE_LOCK, STUDENT, BFCP_LIVE */} 
        {cb_user==='pf' && <Route path="/error/hdc/invalid-clock" element={<NotFound />} />}
        {cb_user==='pf' && <Route path="/error/hdc/login" element={<NotFound />} />}
        {<Route path='/invalid' element={<WRONGPAGEPF />} />}
        {<Route path='/apierror' element={<APIERRORPAGE />} />}
        {cb_user==='pf' && BCFP_ROLES_ARR.includes(getRole(decoder)[0]) && <Route path='/bfcp_he_lock' element={<BFCP_HE_LOCK />} />}
        {cb_user==='st' && <Route element={<WRONGPAGEPF />} />}
        {cb_user==='pf' && BCFP_ROLES_ARR.includes(getRole(decoder)[0]) && <Route path='/bfcp_is_ready_comingsoon' element={<BCF_READY />} />}
    {/* CATEGORY PAGE */}     
        {cb_user==='pf' && sroles.includes(getRole(decoder)[0]) && <Route path='/organizations/:id/categories/:bool/:rolnum' element={<CategoryPage />} />}
    {/* MODULE PAGE AND DEGREE OFFERINGS */}
        {cb_user==='pf' && sroles.includes(getRole(decoder)[0]) && <Route path='/bfcp-majors-degreesofferred/:id/:rolnum' element={<DegreeOfferredPerMajors />} />}
        {cb_user==='pf' && sroles.includes(getRole(decoder)[0]) && <Route path='/bfcp-majors-apcp/:id/:rolnum' element={<APCP />} />}
    {/* LEGAL NOTICE */}  
        {cb_user==='pf' && sroles.includes(getRole(decoder)[0]) && <Route path='/bfcp-legalnotice' element={<LegalNoticePage />} />}
    {/* OTHER NON REGISTERED PATHS */}
        <Route path="/*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
};

VCF.propTypes = {
  invalidClockError: PropTypes.bool,
  timedOut: PropTypes.bool,
  catapultError: PropTypes.bool
};

export default VCF;


const decodePayload = token => {
  const jwtPayload = token.split('.');
  try {
    return JSON.parse(atob(jwtPayload[1]));
  } catch (err) {
    return {};
  }
};

const getRole = rol => {
  const newrole = [];
  const data = [];
  //generate the roles we care about only.
  rol.forEach(({rid}) => {
    if(rid===ADMIN_ROLE || rid===SUBMITTER_ROLE || rid === EDITOR_ROLE || rid===EM_ROLE) {
      data.push(rid);
    }
  });
  //determine the role
  if(data.includes(ADMIN_ROLE)) {
    newrole.push(ADMIN_ROLE);
  } 
  else if(data.includes(EM_ROLE)){
    newrole.push(EM_ROLE);
  }
  else if(data.includes(SUBMITTER_ROLE) && !data.includes(ADMIN_ROLE) && data.includes(EDITOR_ROLE)) {
    newrole.push(SUBMITTER_ROLE); newrole.push(EDITOR_ROLE);
  } else if(data.includes(SUBMITTER_ROLE) && !data.includes(ADMIN_ROLE) && !data.includes(EDITOR_ROLE)) {
    newrole.push(SUBMITTER_ROLE);
  } else if(!data.includes(SUBMITTER_ROLE) && !data.includes(ADMIN_ROLE) && data.includes(EDITOR_ROLE)) {
    newrole.push(EDITOR_ROLE);
  }
  return newrole;
};